import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/cn";

type ButtonVariant = "primary" | "secondary" | "ghost";

interface AdminButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: ButtonVariant;
	size?: "sm" | "md";
	iconOnly?: boolean;
}

export const AdminButton = forwardRef<HTMLButtonElement, AdminButtonProps>(
	({ variant = "ghost", size = "md", iconOnly, className, ...props }, ref) => {
		return (
			<button
				ref={ref}
				className={cn(
					"btn",
					`btn-${variant}`,
					size === "sm" && "btn-sm",
					iconOnly && "btn-icon",
					"active:scale-[0.96] transition-transform",
					className,
				)}
				{...props}
			/>
		);
	},
);
AdminButton.displayName = "AdminButton";
